export const GRID_DEFAULT_STRIP_INDEX = 5;
export const GRID_STRIP_HEIGHT_MOBILE = 900;
export const GRID_STRIP_HEIGHT_DESKTOP = 500;

export const TORPEDO_DEFAULT_STRIP_OFFSET = 2;

export const DISTANCE_FROM_BOTTOM_TO_FETCH_MORE = 1000;
export const ONSCROLLBOTTOM_THROTTLE = 500;
